<template><section><!-- ---
title: JS基础系列之this指针
date: 2022-10-29
tags: JS基础系列
set: BaseJS
--- -->
<p>JS中的<code v-pre>this</code>指向非常复杂，我们这一篇就简单讲解JS中的<code v-pre>this</code>指向规则</p>
<h3>一. 默认绑定</h3>
<p>独立调用函数时，<code v-pre>this</code>都指向<code v-pre>window</code>，跟函数定义的位置没有关系</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">foo</span>(<span class="hljs-params"></span>) </span>{
    <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>)
}
foo() <span class="hljs-comment">// window</span>
</code></pre>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">var</span> obj = {
    <span class="hljs-attr">name</span>: <span class="hljs-string">"CLF"</span>,
    <span class="hljs-attr">foo</span>: <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params"></span>) </span>{
        <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>)
    }
}
<span class="hljs-keyword">var</span> bar = obj.foo
bar() <span class="hljs-comment">// window</span>
</code></pre>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">Func</span>(<span class="hljs-params"></span>) </span>{
    <span class="hljs-keyword">this</span>.name = <span class="hljs-number">123</span>
}
Func.prototype.say = <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params"></span>) </span>{
    <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>)
}
<span class="hljs-keyword">const</span> ff = <span class="hljs-keyword">new</span> Func()
<span class="hljs-keyword">const</span> aFunc = ff.say
aFunc() <span class="hljs-comment">// window</span>
</code></pre>
<h3>二. 隐式绑定</h3>
<p>通过某个对象发起的函数调用<code v-pre>obj.fn</code></p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">var</span> obj = {
    <span class="hljs-attr">name</span>: <span class="hljs-string">"CLF"</span>,
    <span class="hljs-attr">foo</span>: <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params"></span>) </span>{
        <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>)
    }
}
obj.foo() <span class="hljs-comment">// obj</span>
</code></pre>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">var</span> obj1 = {
    <span class="hljs-attr">name</span>: <span class="hljs-string">"obj1"</span>,
    <span class="hljs-attr">foo</span>: <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params"></span>) </span>{
        <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>)
    }
}
<span class="hljs-keyword">var</span> obj2 = {
    <span class="hljs-attr">name</span>: <span class="hljs-string">"obj2"</span>,
    <span class="hljs-attr">bar</span>: obj1.foo
}
obj2.bar() <span class="hljs-comment">// obj2</span>
</code></pre>
<h3>三. 显式绑定</h3>
<p><strong>bind</strong>的绑定优先级高于<code v-pre>apply</code>和<code v-pre>call</code>。通过<code v-pre>bind</code>、<code v-pre>call</code>和<code v-pre>apply</code>绑定执行上下文称为显式绑定</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">foo</span>(<span class="hljs-params"></span>) </span>{
    <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>)
}
<span class="hljs-keyword">var</span> obj = {
    <span class="hljs-attr">name</span>: <span class="hljs-string">"obj"</span>
}
foo.call(obj) <span class="hljs-comment">// obj</span>
foo.apply(obj) <span class="hljs-comment">// obj</span>
foo.apply(<span class="hljs-string">"aaa"</span>) <span class="hljs-comment">// aaa</span>
</code></pre>
</section></template>

